import {REQUEST_ORDER, REQUEST_ORDER_FAILURE, REQUEST_ORDER_SUCCESS} from "../../../constant/transaction/OrderConstant";

const initialState = {
    order: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const orderReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_ORDER:
            return {
                ...state,
                order: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_ORDER_SUCCESS:
            return {
                ...state,
                order: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_ORDER_FAILURE:
            return {
                ...state,
                order: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
